import * as React from "react";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { ProcessTypeHelper } from "../../../Common/Helpers/ProcessTypeHelper";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { AdditionalBankAccount } from "../../../Common/PaymentsIn/BankAccount/AdditionalBankAccount";
import { BankAccountAction } from "../../../Common/PaymentsIn/BankAccount/BankAccountAction";
import { inUseBankAccountForApply } from "../../../Common/PaymentsIn/BankAccount/BankAccountHelper";
import { AssumedSippAndBondHoldings } from "../../../Common/PaymentsIn/SinglePayment/AssumedSippAndBondHoldings";

interface ILegacyProductPaymentsInProps extends IProcessComponentProps {
    data: ApplyModel;
    processType: ProcessType;
}

interface ILegacyProductPaymentsInState {}

export class LegacyProductPaymentsIn extends ProcessComponent<
    ILegacyProductPaymentsInProps,
    ILegacyProductPaymentsInState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
        };
    };

    public isValid(): boolean {
        const isValid = super.isValid();
        return isValid;
    }

    public render(): JSX.Element {
        const { AllBankAccounts, BankAccountInstructions } = this.props.data;
        const { data, onChange } = this.props;
        let hasOnPlatform = false;
        if (
            data?.SelectedProducts.some(
                (ele) => SubAccountTypeHelper.isPP(ele.SubAccountType) || SubAccountTypeHelper.isIsa(ele.SubAccountType) || SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
            )
        ) {
            hasOnPlatform = true;
        }
        return (
            <div>
                <h2>Additional product details</h2>
                {hasOnPlatform && <AssumedSippAndBondHoldings {...this.getProps("AssumedHoldings")} />}
                <AdditionalBankAccount
                    bankAccounts={AllBankAccounts}
                    data={this.props.data}
                    onRef={(ref) => this.appendChild(ref)}
                    bankAccountInstructions={BankAccountInstructions}
                    onChange={() => {}}
                    onSaveNewBankAccountInstruction={(bankAccountInstruction) => {
                        bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                        BankAccountAction.saveBankInstruction(
                            bankAccountInstruction,
                            data.ClientDetails?.ActorId,
                            ProcessTypeHelper.getProcessTypeEnum(this.props.processType),
                            (savedBankAccountInstruction) => {
                                const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                                this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                            }
                        );
                    }}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    onRemoveBankAccountInstruction={(bankAccountInstruction) => {
                        BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                            const changes = (data.BankAccountInstructions || []).filter(
                                (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                            );
                            this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                        });
                    }}
                    inUseBankAccountInstruction={inUseBankAccountForApply(data)}
                />
            </div>
        );
    }
}
